import React from 'react';
import { capitalize } from '../../utilities/strings';
import { useTranslation } from '@michelin/central-provider';
const StringCell = (props) => {
    const { t } = useTranslation();
    return (React.createElement("div", null, capitalize(t(props.value))));
};
export default StringCell;
//# sourceMappingURL=StringCell.js.map